module.exports = __webpack_public_path__ + "static/img/aqzs42.a0862f81.jpg";